import type { PlanItemResponse } from '~~/package/apis/subscription/response/PlanResponse';
import { SubscriptionTier } from '@@/package/mapper/subscription/model/SubscriptionTierType';

export default class PlanModel {
    constructor(
        public id: number,
        public tier: SubscriptionTier,
        public nameKo: string,
        public nameEn: string,
        public monthlyPrice: number,
        public annualPrice: number,
        public annualMonthlyPrice: number,
        public creditUnitPrice: number,
        public currency: 'KRW' | 'USD',
        public country: string,
        public monthlyCreditQuota: number,
        public maxAdmins: number,
        public features: string,
    ) {}

    public static create(data: PlanItemResponse, currency: 'KRW' | 'USD', country: string): PlanModel {
        return new PlanModel(
            data.id,
            data.tier as SubscriptionTier,
            data.nameKo,
            data.nameEn,
            data.monthlyPrice,
            data.annualPrice,
            data.annualMonthlyPrice,
            data.creditUnitPrice,
            currency,
            country,
            data.monthlyCreditQuota,
            data.maxAdmins,
            data.features,
        );
    }

    get currencySymbol(): string {
        return this.currency === 'KRW' ? '₩' : '$';
    }

    public formatPrice(amount: number): string {
        return this.currencySymbol + amount.toLocaleString('en-US');
    }

    public formattedMonthlyPrice(): string {
        return this.formatPrice(this.monthlyPrice);
    }

    public formattedAnnualPrice(): string {
        return this.formatPrice(this.annualPrice);
    }

    public formattedAnnualMonthlyPrice(): string {
        return this.formatPrice(this.annualMonthlyPrice);
    }

    public formattedCreditUnitPrice(): string {
        return this.formatPrice(this.creditUnitPrice);
    }
}
